<template>
    <div id="contact_page">

        <div class="centered_sml">
            <div class="pop_wrapper">

                <h1 class="title">צרו איתנו קשר</h1>

                            
                <div>
                    <div id="dvAjax_signupFRM" class="mtr">
                    <form v-on:submit.prevent="contact_do()" method="post" >
                        
                        <div class="row">
                        <div class="col-md-12">
                            <div class="inputFiled">
                                <label :class="(info.email != '' ? 'filled' : '')">
                                    <input pattern="[a-zA-Z0-9._%+-]+@[a-zA-z0-9.-]+\.[a-zA-z]{2,4}$" type="email" v-model="info.email" name="email" required>
                                    <span class="holder">כתובת מייל</span>
                                </label>
                            </div>
                        </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="inputFiled">
                                    <label :class="(info.name != '' ? 'filled' : '')">
                                        <input type="text"  v-model="info.name" required>
                                        <span class="holder">שם מלא</span>
                                    </label>
                                </div>
                            </div>
                            
                            <div class="col-md-6">
                                <div class="inputFiled">
                                    <label :class="(info.phone != '' ? 'filled' : '')">
                                        <input type="text" placeholder=""  v-model="info.phone" required>
                                        <span class="holder">טלפון</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="inputFiled">
                                    <label :class="(info.subject != '' ? 'filled' : '')">
                                        <input type="text" placeholder=""  v-model="info.subject" required>
                                        <span class="holder">נושא</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-md-12">
                                <div class="inputFiled">
                                    <label :class="(info.content != '' ? 'filled' : '')">
                                        <input type="text" placeholder=""  v-model="info.content" required>
                                        <span class="holder">תוכן</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="sbm_area col-md-12"><input class="btn" type="submit" value="שלח"></div>

                        <div class="clr"></div>
                    </form>
                    </div>
                </div>


            </div>

        </div>
    </div>
</template>

<script>

export default {
  data() {
    return {
      last_views: [],
      info: {
          name: '',
          phone: '',
          email: '',
          subject: '',
          content: '',
      }
    };
  },
  methods: {
    contact_do(){

    this.api_call({ url: 'contact', data: this.info, onComplete: function(){

      alert('הודעתך נשלחה בהצלחה! נציג שלנו יחזור אליך בהקדם.');

    } } );

    }
  },
  created() {

  
    
  }
}
</script>